import { render, staticRenderFns } from "./CombosList.vue?vue&type=template&id=359765d0&"
import script from "./CombosList.vue?vue&type=script&lang=js&"
export * from "./CombosList.vue?vue&type=script&lang=js&"
import style0 from "./CombosList.vue?vue&type=style&index=0&id=359765d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports